import api from "@/api/axios";
import { ElMessage } from 'element-plus'

export default {
  namespaced: true,
  state: {
    summary: {
      total: 0,
      weeklyNew: 0,
      monthlyNew: 0
    },
    notes: [],
    categories: [
      { type: 1, name: '周期复习' },
      { type: 2, name: '随手记事' },
      { type: 3, name: '网址收藏' }
    ],
    currentNote: null,
    isLoading: false,
    error: null,
    pagination: {
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  getters: {
    allNotes: (state) => state.notes,
    noteById: (state) => (id) => state.notes.find((note) => note.id === id),
    notesByCategory: (state) => (type) => {
      return state.notes.filter((note) => note.category === type)
    },
    allCategories: (state) => state.categories,
  },
  mutations: {
    SET_NOTES(state, notes) {
      state.notes = notes;
    },
    ADD_NOTE(state, note) {
      state.notes.push(note);
    },
    UPDATE_NOTE(state, updatedNote) {
      const index = state.notes.findIndex((note) => note.id === updatedNote.id);
      if (index !== -1) {
        state.notes.splice(index, 1, updatedNote);
      }
    },
    DELETE_NOTE(state, id) {
      state.notes = state.notes.filter((note) => note.id !== id);
    },
    SET_CURRENT_NOTE(state, note) {
      state.currentNote = note;
    },
    SET_LOADING(state, status) {
      state.isLoading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
      if (error) {
        ElMessage({
          message: error,
          type: 'error',
          duration: 2000
        });
      }
    },
    ADD_CATEGORY(state, category) {
      if (!state.categories.includes(category)) {
        state.categories.push(category);
      }
    },
    SET_PAGINATION(state, pagination) {
      state.pagination = { ...state.pagination, ...pagination }
    },
    SET_NOTES_SUMMARY(state, summary) {
      state.summary = summary
    },
    UPDATE_CURRENT_NOTE(state, note) {
      state.currentNote = { ...state.currentNote, ...note }
    },
  },
  actions: {
    async fetchNotes({ commit }, { page = 1, pageSize = 9 } = {}) {
      try {
        commit('SET_LOADING', true)
        const response = await api.get(`/records/list_page?page=${page}&page_size=${pageSize}`)
        const data = response.data
        console.log(data);
        if (data.status === 200) {
          commit('SET_NOTES', data.data.list)
          commit('SET_PAGINATION', {
            currentPage: page,
            pageSize: pageSize,
            total: data.data.total
          })
        } else {
          commit('SET_ERROR', data.msg)
        }
      } catch (error) {
        commit('SET_ERROR', '获取笔记列表失败')
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async saveNote({ commit }, note) {
      commit("SET_LOADING", true);
      try {
        const url = note.id ? `/records/${note.id}` : "/notes";
        const { data } = await api.post(url, note);

        if (note.id) {
          commit("UPDATE_NOTE", data);
        } else {
          commit("ADD_NOTE", data);
        }
        return data;
      } catch (error) {
        commit("SET_ERROR", error.message);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async deleteNote({ commit }, id) {
      commit("SET_LOADING", true);
      try {
        const res = await api.delete(`/records/${id}`);
        console.log(res);
        if (res.data.status === 200) {
          commit("DELETE_NOTE", id);
        } else {
          commit("SET_ERROR", res.data.msg);
        }
      } catch (error) {
        commit("SET_ERROR", error.message);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchNoteById({ commit }, id) {
      commit("SET_LOADING", true);
      try {
        const response = await api.get(`/records/${id}`);
        if (response.data.status === 200) {
          commit("SET_CURRENT_NOTE", response.data.data);
        } else {
          commit("SET_ERROR", response.data.msg);
        }
      } catch (error) {
        commit("SET_ERROR", "获取笔记失败");
        console.error("获取笔记失败:", error);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async createNote({ commit }, noteData) {
      commit("SET_LOADING", true);
      try {
        const response = await api.post("/records/add", noteData);
        if (response.data.status === 200) {
          commit("ADD_NOTE", response.data.data);
          commit("SET_CURRENT_NOTE", response.data.data);
        } else {
          commit("SET_ERROR", response.data.msg);
        }
        return response;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async updateNote({ commit }, { data }) {
      commit("SET_LOADING", true);
      try {
        const response  = await api.post(`/records/update`, data);
        console.log(response);
        if (response.data.status === 200) {
          commit("UPDATE_NOTE", response.data.data);
          commit("SET_CURRENT_NOTE", response.data.data);
        } else {
          commit("SET_ERROR", response.data.msg);
        }
        return response;

      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchNotesStats({ commit }) {
      try {
        const response = await api.get('/records/summary')
        commit('SET_NOTES_SUMMARY', response.data.data)
      } catch (error) {
        console.error('获取笔记统计失败:', error)
        ElMessage.error('获取笔记统计失败')
      }
    },

    async uploadImage(_, formData) {
      const response = await api.post('/upload/image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      
      if (response.data.status === 200) {
        return response.data.data
      } else {
        throw new Error(response.data.msg || '上传失败')
      }
    },

    // 删除图片
    async deleteImage(_, imageUrl) {
      try {
        // 从 URL 中获取图片文件名        
        // 调用删除图片 API
        const response = await api.post(`/upload/delete`, {
          file_url: imageUrl
        })
        
        if (response.data.status === 200) {
          return response.data
        } else {
          throw new Error(response.data.message || '删除图片失败')
        }
      } catch (error) {
        console.error('删除图片失败:', error)
        throw error
      }
    },
  },
};
